export const getImageDimensionsFromDataUrl = (dataUrl: string) =>
  new Promise<{ width: number; height: number }>((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      resolve({ height: image.height, width: image.width });
    };

    image.onerror = () => {
      reject(new Error("Failed to read image."));
    };

    image.src = dataUrl;
  });

export function preloadImage(url: string | null) {
  if (!url) {
    return;
  }

  const image = new Image();
  image.src = url;
}
